/**
 * @generated SignedSource<<3c039fbb9ef094640da3fa8787cab0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user" | "ProductInternalTools_user">;
  readonly " $fragmentType": "ProductBaseTile_user";
};
export type ProductBaseTile_user$key = {
  readonly " $data"?: ProductBaseTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showMerchandizingTool"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductDetails_user"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showMerchandizingTool",
          "variableName": "showMerchandizingTool"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductInternalTools_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "68bd4383e66dd1aa11b2767c1edd729a";

export default node;
